import { createFeatureSelector, select } from '@ngrx/store';
import { filter, map, pipe } from 'rxjs';
import * as fromAuth from './auth.reducer';

export const selectAuthState = createFeatureSelector<fromAuth.State>(
  fromAuth.authFeatureKey,
);

export const {
  selectUser: selectAuthenticatedUser,
  selectError: selectAuthError,
  selectStatus: selectAuthStatus,
  selectLoading: selectAuthLoading,
} = fromAuth.authFeature;

export const selectIsAuthenticated = pipe(
  select(selectAuthState),
  filter(({ status }) => status !== fromAuth.AuthStatus.Pending),
  map(({ user }) => !!user),
);
